export default function BrandMark({ size = "large" }) {
  const className = size === "small" ? "brand-mark brand-mark-small" : "brand-mark";

  return (
    <div className={className} aria-hidden="true">
      <div className="brand-ring" />
      <div className="brand-trail brand-trail-top" />
      <div className="brand-trail brand-trail-bottom" />
      <div className="brand-swoosh" />
      <div className="brand-bars">
        <span />
        <span />
        <span />
      </div>
      <div className="brand-chain">
        <span />
        <span />
      </div>
    </div>
  );
}
